import React from "react";
import { Link } from "react-router-dom";
import { Facebook, Instagram, Twitter, Linkedin } from "lucide-react";

export default function Footer() {
  return (
    <footer className="relative" style={{ background: "#0F2B5B", borderTop: "0.5px solid rgba(255,255,255,0.10)" }} data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 py-14 grid grid-cols-2 md:grid-cols-6 gap-10">
        <div className="col-span-2 md:col-span-2">
          <Link to="/" className="flex items-center gap-2.5">
            <span className="inline-flex h-10 w-10 rounded-lg bg-white overflow-hidden">
              <img src="/logos/metaconnect.jpeg" alt="MetaConnect" className="h-full w-full object-cover" />
            </span>
            <span className="font-display font-semibold text-[18px]" style={{ color: "#ffffff" }}>MetaConnect</span>
          </Link>
          <p className="mt-5 text-[14px] max-w-sm leading-relaxed" style={{ color: "#93B4D4" }}>
            Architecture e-santé prête à l&apos;emploi pour concevoir, déployer et opérer
            des parcours numériques de soins sécurisés et conformes aux référentiels nationaux.
          </p>
          <div className="flex items-center gap-3 mt-6">
            {[
              { Icon: Linkedin, href: "https://www.linkedin.com/company/105187725/", label: "linkedin" },
            ].map(({ Icon, href, label }) => (
              <a
                key={label}
                href={href}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={`MetaConnect sur ${label}`}
                data-testid={`footer-social-${label}`}
                className="h-9 w-9 rounded-full grid place-items-center transition"
                style={{ border: "0.5px solid rgba(255,255,255,0.22)", color: "#B8D4E8" }}
              >
                <Icon size={16} />
              </a>
            ))}
          </div>
        </div>

        <FooterCol title="Navigation">
          <FLink to="/solutions">Solutions</FLink>
          <FLink to="/conformite">Conformité</FLink>
          <FLink to="/blog">Blog</FLink>
          <FLink to="/demo">Démo guidée</FLink>
          <FLink to="/mssante/connexion">Espace pro</FLink>
          <FLink to="/agenda">Agenda et rendez-vous</FLink>
          <FLink to="/agenda-type">Exemples d’agendas</FLink>
          <FLink to="/dossier-patient">Dossier patient</FLink>
        </FooterCol>

        <FooterCol title="Briques MetaBridge">
          <FLink to="/services/dmp">MetaBridge DMP</FLink>
          <FLink to="/mssante">MetaBridge MSSanté</FLink>
          <FLink to="/services/ins">MetaBridge INS</FLink>
          <FLink to="/services/psc">MetaBridge PSC</FLink>
          <FLink to="/services/fhir">MetaBridge FHIR</FLink>
        </FooterCol>

        <FooterCol title="Pour qui">
          <FLink to="/solutions#editeurs">Éditeurs de logiciels</FLink>
          <FLink to="/solutions#professionnels">Professionnels de santé</FLink>
          <FLink to="/solutions#industriels">Établissements &amp; CPTS</FLink>
          <FLink to="/solutions#institutions">Porteurs de projets</FLink>
        </FooterCol>

        <FooterCol title="NET · Assistant IA">
          <FLink to="/net">Découvrir NET</FLink>
          <FLink to="/net/opticien">NET Opticiens</FLink>
          <FLink to="/net/audioprothesiste">NET Audioprothésistes</FLink>
          <FLink to="/net/groupements">NET Groupements</FLink>
          <FLink to="/net/industriels">NET Industriels</FLink>
          <FLink to="/net/editeurs">NET Éditeurs</FLink>
        </FooterCol>

        <FooterCol title="Métiers MSSanté">
          <FLink to="/mssante-medecin">MSSanté Médecin</FLink>
          <FLink to="/mssante-infirmier-liberal">MSSanté Infirmier libéral</FLink>
          <FLink to="/mssante/opticien">MSSanté Opticien</FLink>
          <FLink to="/mssante/audioprothesiste">MSSanté Audioprothésiste</FLink>
          <FLink to="/mssante/professionnels-de-sante">Tous les professionnels</FLink>
          <FLink to="/mssante/inscription">Créer ma BAL MSSanté</FLink>
        </FooterCol>

        <FooterCol title="Légal">
          <FLink to="/mentions-legales">Mentions légales</FLink>
          <FLink to="/cgu">CGU MetaConnect</FLink>
          <FLink to="/cgv">CGV MetaConnect</FLink>
          <FLink to="/donnees">Charte de protection des données</FLink>
          <FLink to="/contrat">Contrat opérateur MSSanté</FLink>
          <button onClick={() => { try { localStorage.removeItem("mc_cookie_consent_v1"); window.location.reload(); } catch (e) { console.warn("cookie reset failed", e); } }}
                  data-testid="footer-cookie-prefs"
                  className="text-[13px] text-[var(--mc-muted)] hover:text-white transition text-left">
            Gérer mes cookies
          </button>
        </FooterCol>
      </div>

      <div className="border-t border-[rgba(127,179,255,0.10)]">
        <div className="max-w-7xl mx-auto px-5 lg:px-8 py-5 flex flex-col md:flex-row items-start md:items-center justify-between gap-3">
          <p className="text-[12px] text-[var(--mc-muted)]">
            © {new Date().getFullYear()} MetaConnect — metaconnect.fr · Hébergement HDS · RGPD
          </p>
          <p className="text-[12px] text-[var(--mc-muted)]">
            Conforme aux référentiels nationaux du numérique en santé
          </p>
        </div>
      </div>
    </footer>
  );
}

function FooterCol({ title, children }) {
  return (
    <div>
      <div className="text-[12px] uppercase tracking-[0.18em] text-[var(--mc-blue-300)] mb-4">{title}</div>
      <ul className="flex flex-col gap-2.5 text-[14px]">{children}</ul>
    </div>
  );
}

function FLink({ to, children }) {
  return (
    <li>
      <Link to={to} className="text-[var(--mc-muted)] hover:text-white link-underline transition">
        {children}
      </Link>
    </li>
  );
}
